export function getLayoutClassName(sidebarCollapsed: boolean, isQuickStartPage: boolean): string {
  return ['app-layout', sidebarCollapsed ? 'collapsed' : '', isQuickStartPage ? 'quick-start-layout' : '']
    .filter(Boolean)
    .join(' ')
}
